import React, { useEffect, useState } from 'react'
import fetchHook from '../../../hooks/fetchMSSQL-hook'
import NoResults from '../../../components/NoResults/NoResults'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export default function CashRegistersList() {
  const [cashRegisters, setCashRegisters] = useState([])
  const { fetchMssqlApi } = fetchHook()

  const getCashRegisters = () => {
    return fetchMssqlApi(`cashRegisters/null`, {}, res => setCashRegisters(res))
  }

  useEffect(() => {
    getCashRegisters()
  }, [])

  const getTypeOfWork = (cashRegister) => {
    switch (cashRegister.TypeOfWork) {
      case 'Tylko do odczytu':
        return (
          <h5 className="mb-0 p-2" style={{ fontSize: '1.3rem' }}>
            <div className={`p-2 badge bg-yellow text-white`}>
              {cashRegister.TypeOfWork}
            </div>
          </h5>
        )
      case 'Fiskalny (środowisko testowe)':
        return (
          <h5 className="mb-0 p-2" style={{ fontSize: '1.3rem' }}>
            <div className={`p-2 badge badge-primary`}>
              {cashRegister.TypeOfWork}
            </div>
          </h5>
        )
      case 'Fiskalny':
        return (
          <h5 className="mb-0 p-2" style={{ fontSize: '1.3rem' }}>
            <div className={`p-2 badge badge-success`}>
              {cashRegister.TypeOfWork}
            </div>
          </h5>
        )
      case 'Obsługi':
        return (
          <h5 className="mb-0 p-2" style={{ fontSize: '1.3rem' }}>
            <div className={`p-2 badge badge-secondary`}>
              {cashRegister.TypeOfWork}
            </div>
          </h5>
        )
      default:
        return (
          <h5 className="mb-0 p-2" style={{ fontSize: '1.3rem' }}>
            <div className={`p-2 badge badge-danger`}>
              Nie rozpoznano
            </div>
          </h5>
        )
    }
  }

  const downloadUnregisterPdf = (cr) => {
    fetchMssqlApi(
      `cashRegisters/unregister-pdf/${cr.CashRegisterId}`,
      { method: 'GET', responseType: 'blob', hideNotification: true },
      (res) => {
        const blob = new Blob([res], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const safe = (v) => String(v || '').replace(/[^\w\-]+/g, '_')
        const name = `WNIOSEK_WYREJESTROWANIE_${safe(cr.NrUnik)}_${safe(cr.NrEwid)}.pdf`

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      },
      (err) => {
        console.error(err)
        window.alert('Nie udało się pobrać PDF (Zgłoszenie US).')
      }
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between">
          <div></div>
          {JSON.parse(localStorage.getItem('lastLogin')).email === 'serwis@retail24.pl' && (
            <Link
              to={`/wkf/cashRegister/0`}
              className="btn text-nowrap btn-outline-secondary"
            >
              <i className="fas fa-plus" />
            </Link>
          )}
        </div>
      </div>

      {cashRegisters.length ? (
        <table className="table table-striped">
          <thead>
            <tr className='text-center headers-color pe-none'>
              <th>Numer fabryczny</th>
              <th>Przypisany automat</th>
              <th>Numer ewidencyjny</th>
              <th>Numer unikatowy</th>
              <th>Tryb pracy</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {cashRegisters.map((cr, idx) => (
              <tr key={idx} className='text-center'>
                <td>{cr.TSN}</td>
                <td>{cr.MachineName}</td>
                <td>{cr.NrEwid}</td>
                <td>{cr.NrUnik}</td>
                <td>
                  <div className="h-100 w-100 justify-content-center align-items-center">
                    {getTypeOfWork(cr)}
                  </div>
                </td>

                <td>
                  <div className="d-flex justify-content-end border-0 mt-2 mb-2">

                    {cr.TypeOfWork === 'Tylko do odczytu' && (
                      <button
                        className="mr-3 btn btn-outline-primary btn-sm"
                        onClick={() => downloadUnregisterPdf(cr)}
                        title="Zgłoszenie US"
                      >
                        Zgłoszenie US
                      </button>
                    )}

                    <Link
                      className="mr-4 btn btn-outline-primary btn-sm"
                      to={`/wkf/cashRegister/${cr.CashRegisterId}`}
                    >
                      Podgląd
                    </Link>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoResults />
      )}
    </div>
  )
}